import { render, staticRenderFns } from "./FilterDetails.vue?vue&type=template&id=186baccb&scoped=true&"
import script from "./FilterDetails.vue?vue&type=script&lang=js&"
export * from "./FilterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186baccb",
  null
  
)

export default component.exports